'use client';

import { Typography } from '@bgzt/ui';
import Image from 'next/image';

import { findShop } from '~/utils/shop-service';

import styles from './ShopInfo.module.css';

type Props = {
  shopId: string;
};

export const ShopInfo = ({ shopId }: Props) => {
  const shop = findShop(shopId);
  return (
    <div className={styles.shopInfoContainer}>
      <div className={styles.shopInfoImage}>
        {shop && <Image src={shop.images.logo} alt={`${shop.shopNameKor} 로고`} width={44} height={44} unoptimized />}
      </div>
      <div className={styles.shopInfo}>
        <Typography variant="L4" color="gray-900">
          {shop?.shopNameKor}
        </Typography>
        <br />
        <Typography variant="L12" color="gray-300">
          {shop?.shopNameEng}
        </Typography>
      </div>
    </div>
  );
};
